import { render, staticRenderFns } from "./SearchResultSItem.vue?vue&type=template&id=0a1c3e52&"
import script from "./SearchResultSItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultSItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports